/* TRATANTE® v2 — extras: parallax da abertura da coleção, newsletter em folha, cookies, voltar, copiar, ajuda */
(() => {
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const ls = { get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }, set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} } };
  const U = () => window.TRTui || {};

  // parallax na foto de abertura da coleção
  const hi = $('.col-hero-img');
  if (hi && !RM) {
    let t = false;
    addEventListener('scroll', () => { if (t) return; t = true; requestAnimationFrame(() => { t = false; const y = scrollY; if (y < innerHeight * 1.2) hi.style.transform = `translate3d(0,${(y * .35).toFixed(1)}px,0)`; }); }, { passive: true });
  }

  // newsletter: a Shopify recarrega com ?customer_posted=true#<id do formulário>
  if (/customer_posted=true/.test(location.search)) {
    if (location.hash === '#nlSheet') {
      const b = document.createElement('button'); b.type = 'button'; b.hidden = true; b.dataset.open = 'nl'; document.body.appendChild(b);
      setTimeout(() => b.click(), 400);
    } else if (location.hash === '#nlForm') { const nf = $('#newsletter'); if (nf) setTimeout(() => nf.scrollIntoView({ block: 'center' }), 300); }
  }

  // voltar: se vieste de dentro da loja, recua no histórico (volta ao sítio exato)
  document.addEventListener('click', e => {
    const a = e.target.closest('[data-back]'); if (!a) return;
    try { const r = new URL(document.referrer); if (r.origin === location.origin && history.length > 1) { e.preventDefault(); history.back(); } } catch (err) {}
  }, true);

  // copiar email / telefone
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-copy]'); if (!b) return;
    const v = b.dataset.copy, done = () => (U().toast ? U().toast(__('Copiado.')) : null);
    if (navigator.clipboard) navigator.clipboard.writeText(v).then(done).catch(() => U().toast && U().toast(v)); else if (U().toast) U().toast(v);
  });

  // ajuda: abrir na secção certa (#envios, #trocas…) com espaço para o cabeçalho
  const help = $('#helpPage');
  if (help) {
    const start = (location.hash || '').slice(1) || help.dataset.start;
    const el = start && document.getElementById(start);
    if (el && help.contains(el)) setTimeout(() => window.scrollTo(0, el.getBoundingClientRect().top + scrollY - 110), 60);
    if (/contact_posted=true/.test(location.search)) { const f = $('#helpForm'); if (f) { const d = f.closest('details'); if (d) d.open = true; setTimeout(() => f.scrollIntoView({ block: 'center' }), 120); } }
  }

  // cookies: o aviso da TRATANTE, ligado à API de consentimento da Shopify
  const bar = $('#cookieBar'), prefs = $('#cookiePrefs'), KEY = 'trt-consent';
  const cpApi = () => (window.Shopify && window.Shopify.customerPrivacy) || null;
  const nativeBanner = () => !!(window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function');
  function showBar() { if (!bar) return; bar.hidden = false; requestAnimationFrame(() => bar.classList.add('on')); }
  function hideBar() { if (!bar) return; bar.classList.remove('on'); setTimeout(() => { bar.hidden = true; }, RM ? 0 : 400); }
  function decide(ok) {
    ls.set(KEY, ok ? 'yes' : 'no');
    const cp = cpApi();
    if (cp && typeof cp.setTrackingConsent === 'function') { try { cp.setTrackingConsent({ analytics: ok, marketing: ok, preferences: ok, sale_of_data: ok }, () => {}); } catch (e) {} }
    hideBar();
    if (U().say) U().say(ok ? __('Cookies aceites.') : __('Cookies recusados.'));
  }
  if (bar) { $('#cbYes').onclick = () => decide(true); $('#cbNo').onclick = () => decide(false); }
  function decidedInShopify() {
    const cp = cpApi(); if (!cp || typeof cp.currentVisitorConsent !== 'function') return false;
    try { return Object.values(cp.currentVisitorConsent() || {}).some(v => v === 'yes' || v === 'no'); } catch (e) { return false; }
  }
  function startConsent() {
    if (prefs) { prefs.hidden = false; prefs.onclick = () => { if (nativeBanner()) window.privacyBanner.showPreferences(); else showBar(); }; }
    if (!bar || nativeBanner()) return;             // banner da Shopify ativo: não mostrar dois
    if (window.Shopify && window.Shopify.designMode) return;
    if (!ls.get(KEY) && !decidedInShopify()) showBar();
  }
  const load = () => {
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => setTimeout(startConsent, 600));
    } else setTimeout(startConsent, 600);
  };
  if (document.readyState === 'complete') load(); else addEventListener('load', load);
})();

/* Chat no menu: abre o Shopify Inbox sem a bolha; sem chat, segue para Contacto */
(function(){
  function chatBtn(){
    var h=document.querySelector('shopify-chat'); var r=h&&h.shadowRoot&&h.shadowRoot.querySelector('shopify-agent-runtime');
    var s=r&&r.shadowRoot; return s&&s.querySelector('[part~=activator]');
  }
  document.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('[data-chat]'); if(!a) return;
    var b=chatBtn(); if(!b) return; /* sem chat carregado: o link leva a Contacto */
    e.preventDefault();
    var m=document.getElementById('menu'); var x=m&&!m.hidden&&m.querySelector('[data-close]');
    if(x) x.click();
    function isOpen(){ var h=document.querySelector('shopify-chat'); var r=h&&h.shadowRoot&&h.shadowRoot.querySelector('shopify-agent-runtime'); return !!(r&&r.hasAttribute('open')); }
    setTimeout(function(){ var c=chatBtn(); if(!c) return; if(!isOpen()) c.click();
      setTimeout(function(){ if(!isOpen()){ var c2=chatBtn(); if(c2) c2.click(); } }, 1500); /* 1.º toque às vezes só arranca o chat */
    }, x?420:0);
  });
})();

/* "Aplica já no carrinho": aplica o código sem sair da página, confirma e abre o carrinho se tiver peças.
   Sem JavaScript, a ligação /discount/CODIGO faz o mesmo e volta à página. */
document.addEventListener('click', function(e){
  var a = e.target.closest && e.target.closest('[data-apply-code]'); if (!a) return;
  e.preventDefault();
  var code = a.getAttribute('data-apply-code'), ui = window.TRTui || {};
  a.setAttribute('aria-busy', 'true'); a.textContent = __('A aplicar…');
  fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
    .then(function(){ return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
    .then(function(r){ return r.json(); })
    .then(function(c){
      var ok = (c.discount_codes || []).some(function(d){ return (d.code || '').toUpperCase() === code.toUpperCase(); });
      a.removeAttribute('aria-busy');
      if (!ok) { a.textContent = __('Ou aplica já no carrinho'); if (ui.toast) ui.toast(__('Não deu para aplicar. Usa {c} no checkout.', { c: code })); return; }
      a.textContent = __('Aplicado');
      if (ui.toast) ui.toast(c.item_count ? __('{c} aplicado. Já está no carrinho.', { c: code }) : __('{c} guardado. Desconta quando juntares peças.', { c: code }));
      if (c.item_count) {
        if (ui.closeDialog && document.body.classList.contains('locked')) ui.closeDialog(false);
        setTimeout(function(){ var b = document.getElementById('cartBtn'); if (b) b.click(); }, 450);
      }
    })
    .catch(function(){ location.href = a.href; });
});

/* Pesquisa no menu: sugestões enquanto se escreve (API de pesquisa preditiva da Shopify) */
(function(){
  var q = document.getElementById('menuQ'); if (!q) return;
  var form = q.closest('form');
  var box = document.createElement('div'); box.className = 'ps'; box.id = 'menuSugg'; box.hidden = true;
  box.setAttribute('role', 'region'); box.setAttribute('aria-label', __('Sugestões'));
  form.insertAdjacentElement('afterend', box);
  q.setAttribute('aria-controls', 'menuSugg');
  var t, ctrl, last = '';
  function ui(){ return window.TRTui || {}; }
  function esc(s){ return (ui().esc || String)(s); }
  function hide(){ box.hidden = true; box.innerHTML = ''; }
  function render(term, list){
    if (!list.length) { box.innerHTML = '<p class="ps-empty">' + __('Nada com “{q}”. Tenta outra palavra.', { q: esc(term) }) + '</p>'; box.hidden = false; return; }
    var money = ui().money || function(c){ return (c / 100).toFixed(2).replace('.', ',') + ' €'; };
    var pname = ui().pname || function(x){ return x; };
    box.innerHTML = '<ul class="ps-list">' + list.map(function(p){
      var img = p.image || (p.featured_image && p.featured_image.url) || '';
      if (img) img = img + (img.indexOf('?') < 0 ? '?' : '&') + 'width=120';
      var cents = Math.round(parseFloat(p.price) * 100) || 0;
      return '<li><a href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="44" height="55">' : '<span class="ps-ph"></span>') +
        '<span class="ps-nm">' + esc(pname(p.title)) + '<small>' + esc(p.type || '') + '</small></span><b>' + money(cents) + '</b></a></li>';
    }).join('') + '</ul><a class="ps-all" href="' + form.action + '?type=product&q=' + encodeURIComponent(term) + '">' + __('Ver todos os resultados') + '</a>';
    box.hidden = false;
  }
  function run(){
    var term = q.value.trim();
    if (term.length < 2) { last = ''; hide(); return; }
    if (term === last) return; last = term;
    if (ctrl) ctrl.abort(); ctrl = window.AbortController ? new AbortController() : null;
    fetch(__u('/search/suggest.json') + '?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', ctrl ? { signal: ctrl.signal } : {})
      .then(function(r){ return r.json(); })
      .then(function(d){ if (q.value.trim() !== term) return; render(term, (d.resources && d.resources.results && d.resources.results.products) || []); })
      .catch(function(){});
  }
  q.addEventListener('input', function(){ clearTimeout(t); t = setTimeout(run, 220); });
  q.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !box.hidden) { e.stopPropagation(); q.value = ''; last = ''; hide(); } });
})();
